import * as Yup from 'yup';

export default Yup.object().shape({
  pageName: Yup.string(),
  tasks: Yup.array().of(Yup.object().shape({
    questionType: Yup.string(),
    leftLabel: Yup.string().nullable().when('questionType', (questionType, schema) => {
      if (questionType === 'range') {
        return Yup.string().required('Required');
      }
      return schema;
    }),
    rightLabel: Yup.string().nullable().when('questionType', (questionType, schema) => {
      if (questionType === 'range') {
        return Yup.string().required('Required');
      }
      return schema;
    }),
    label: Yup.string().when('questionType', (questionType, schema) => {
      if (questionType === 'url') {
        return schema.trim().url(
          'Please check if the URL contains:\n\u2022 https:// or http://\n\u2022 top-level domain (example: .com .net .org etc)',
        ).required('Required');
      }
      return schema.required('Required');
    }),
    questionOptions: Yup.array().of(Yup.object().shape({
      label: Yup.string().required('required'),
    })),
    blurVideo: Yup.boolean(),
    imageKey: Yup.string().nullable().when('questionType', (questionType, schema) => {
      if (questionType === 'image_select') {
        return schema.required('Image required');
      }
      return schema;
    }),
    imageUrl: Yup.string().nullable().when('questionType', (questionType, schema) => {
      if (questionType === 'image_select') {
        return schema.required('Required');
      }
      return schema;
    }),
    videoKey: Yup.string().nullable().when('questionType', (questionType, schema) => {
      if (questionType === 'audio_video') {
        return schema.required('Video required');
      }
      return schema;
    }),
    videoUrl: Yup.string().nullable().when('questionType', (questionType, schema) => {
      if (questionType === 'audio_video') {
        return schema.required('Required');
      }
      return schema;
    }),
  })).required('Please add at least 1 question to the study.'),
});
